import React from 'react';
import { getPageLogoUrl, intl } from 'ehs-react';
import { usePortletStore } from '../App';

function LogoComponent(): JSX.Element {
  const welcomePageUrl = usePortletStore(
    state => state.configuration.welcomePageUrl
  );

  return (
    <div className="welcome-logo-container">
      <a href={welcomePageUrl} className="logo default-logo">
        <img
          className="welcome-logo"
          src={getPageLogoUrl()}
          alt={intl('resetpasswordportlet.logo.healthineers')}
        />
      </a>
    </div>
  );
}

export const Logo = LogoComponent;
